'use client'

import { useContext } from 'react'
import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { BrazeContext } from '@marketplace-web/braze/braze-feature'
import { deleteConversation } from '@marketplace-web/messaging/conversation-messaging-data'

type Props = {
  show: boolean
  conversationId: string | number
  onConfirm: () => void
  onCancel: () => void
}

const DeleteConversationModal = ({ conversationId, show, onConfirm, onCancel }: Props) => {
  const translate = useTranslate('conversation.conversation_info.delete_conversation_modal')
  const { logCardDismissal } = useContext(BrazeContext)

  const handleDeleteClick = async () => {
    if (typeof conversationId === 'string') logCardDismissal(String(conversationId))

    await deleteConversation(conversationId)

    onConfirm()
  }

  return (
    <Dialog
      show={show}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('buttons.confirm'),
          style: Dialog.ActionStyling.Filled,
          theme: 'warning',
          callback: handleDeleteClick,
        },
        {
          text: translate('buttons.cancel'),
          style: Dialog.ActionStyling.Flat,
          theme: 'warning',
          callback: onCancel,
        },
      ]}
    />
  )
}

export default DeleteConversationModal
